import { MenuItem, Stack, Typography, useTheme } from "@mui/material";
import { TenantContractResponse } from "../../dtos/tenants";

import {
  ExtendContractAction,
  TerminateContractAction,
} from "./contracts/actions-menu";
import TenantsHistory from "./history";
import TenantsPaymentPlans from "./payment-plans";
import { useState } from "react";
import MoreActionsMenu from "@/modules/common/components/ui-kit/menus/more-actions-menu";

const TenantDetailsMenu = ({
  propertyUid,
  contractUid,
  endDate,
}: Readonly<{ propertyUid: string; contractUid: string; endDate: string }>) => {
  const [historyOpen, setHistoryOpen] = useState(false);

  const handleOpenHistory = () => {
    setHistoryOpen(true);
  };

  const handleCloseHistory = () => {
    setHistoryOpen(false);
  };
  return (
    <>
      <MoreActionsMenu>
        <ExtendContractAction contractUid={contractUid} endDate={endDate} />
        <MenuItem onClick={handleOpenHistory}>
          <Typography fontSize={14}>Tenant History</Typography>
        </MenuItem>
        <TerminateContractAction contractUid={contractUid} />
      </MoreActionsMenu>
      <TenantsHistory
        propertyUid={propertyUid}
        open={historyOpen}
        handleOpen={() => setHistoryOpen(true)}
        handleClose={handleCloseHistory}
      />
    </>
  );
};

function TenantDetails({
  currentTenantContract,
  propertyUid,
}: Readonly<{
  currentTenantContract: TenantContractResponse;
  propertyUid: string;
}>) {
  const theme = useTheme();
  const formattedDate = (date: string) => {
    return new Date(date).toLocaleDateString("en-GB", {
      month: "short",
      day: "numeric",
      year: "numeric",
    });
  };
  return (
    <Stack gap={(theme) => theme.nawy.spacing["md"]}>
      <Stack
        justifyContent="space-between"
        alignItems="center"
        direction="row"
        width="100%"
      >
        <Typography fontSize={14} fontWeight={600}>
          Tenant details
        </Typography>

        <TenantDetailsMenu
          propertyUid={propertyUid}
          contractUid={currentTenantContract?.uid}
          endDate={currentTenantContract?.endDate ?? ""}
        />
      </Stack>

      <Stack
        direction="row"
        width="100%"
        columnGap={(theme) => theme.nawy.spacing["2xl"]}
        rowGap={(theme) => theme.nawy.spacing["sm"]}
        flexWrap="wrap"
      >
        <Stack>
          <Typography
            fontSize={11}
            color={theme.nawy.colors.primitives.grey[700]}
          >
            Name
          </Typography>
          <Typography fontSize={14}>
            {currentTenantContract?.tenantContract.customerName}
          </Typography>
        </Stack>

        <Stack>
          <Typography
            fontSize={11}
            color={theme.nawy.colors.primitives.grey[700]}
          >
            Number
          </Typography>
          <Typography fontSize={14}>
            {currentTenantContract?.tenantContract.customerPhoneNumber}
          </Typography>
        </Stack>
        <Stack>
          <Typography
            fontSize={11}
            color={theme.nawy.colors.primitives.grey[700]}
          >
            Rental Duration
          </Typography>
          <Typography fontSize={14}>
            {currentTenantContract?.startDate
              ? formattedDate(currentTenantContract?.startDate)
              : "--"}
            {" - "}
            {currentTenantContract?.endDate
              ? formattedDate(currentTenantContract?.endDate)
              : "--"}
          </Typography>
        </Stack>
        <Stack>
          <Typography
            fontSize={11}
            color={theme.nawy.colors.primitives.grey[700]}
          >
            Rental Amount
          </Typography>
          <Typography fontSize={14}>
            EGP{" "}
            {Number(
              currentTenantContract?.tenantContract.rentStartValue
            ).toLocaleString()}
          </Typography>
        </Stack>
      </Stack>

      <TenantsPaymentPlans
        paymentPlans={currentTenantContract?.projectTransactions ?? []}
      />
    </Stack>
  );
}

export default TenantDetails;
